import { create } from 'zustand';
import type { Workflow } from '../schemas';
import { mockWorkflows } from '../data/mockWorkflows';

interface WorkflowState {
  workflows: Workflow[];
  isLoading: boolean;
  addWorkflow: (workflow: Omit<Workflow, 'id' | 'createdAt' | 'updatedAt'>) => void;
  updateWorkflow: (id: string, updates: Partial<Workflow>) => void;
  deleteWorkflow: (id: string) => void;
  getWorkflow: (id: string) => Workflow | undefined;
}

export const useWorkflowStore = create<WorkflowState>()((set, get) => ({
  workflows: mockWorkflows,
  isLoading: false,
  addWorkflow: workflow => {
    const newWorkflow: Workflow = {
      ...workflow,
      id: Math.random().toString(36).substr(2, 9),
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    };
    set(state => ({ workflows: [...state.workflows, newWorkflow] }));
  },
  updateWorkflow: (id, updates) => {
    set(state => ({
      workflows: state.workflows.map(w =>
        w.id === id ? { ...w, ...updates, updatedAt: new Date().toISOString() } : w,
      ),
    }));
  },
  deleteWorkflow: id => {
    set(state => ({ workflows: state.workflows.filter(w => w.id !== id) }));
  },
  getWorkflow: id => {
    return get().workflows.find(w => w.id === id);
  },
}));
